module.exports = __webpack_public_path__ + "img/37-image-2@2x.497af970.png";